import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Breadcrumb, BreadcrumbItem, Card } from 'reactstrap';
import { HomeButton } from '../../components/HomeButton/home-button';
import { useStateSelector } from '../../store/selectors';
import { USER_ROLES } from '../../utils/constants';
import TimelineTemplates from './MarketplaceTabs/TimelineTemplates/TimelineTemplates';
import { MarketplaceBuyers } from './MarketplaceTabs/MarketplaceBuyers/MarketplaceBuyers';
import Engagements from './MarketplaceTabs/Engagements/Engagements';
import { useSearchParams } from 'react-router-dom';
import DocumentTemplates from './MarketplaceTabs/DocumentTemplates/DocumentTemplates';
import {
    AdminMarketplaceTab,
    AdminMarketplaceTabs,
} from '../../slices/marketplace/timeline/models/enums/amin-marketplace-tab.enum';
import MarketplaceSettings from './MarketplaceTabs/MarketplaceSettings/MarketplaceSettings';

const AdminMarketplace = () => {
    const tabComponents = [
        { id: AdminMarketplaceTab.Engagements, content: () => <Engagements /> },
        {
            id: AdminMarketplaceTab.TimelineTemplates,
            content: () => <TimelineTemplates />,
        },
        {
            id: AdminMarketplaceTab.MarketplaceBuyers,
            content: () => <MarketplaceBuyers />,
        },
        {
            id: AdminMarketplaceTab.DocumentTemplates,
            content: () => <DocumentTemplates />,
        },
        {
            id: AdminMarketplaceTab.MarketplaceSettings,
            content: () => <MarketplaceSettings />,
        },
    ];
    const sellerFeature_2_3_Tabs = [AdminMarketplaceTab.MarketplaceSettings];
    const [searchParams, setSearchParams] = useSearchParams({});
    const userSummary = useStateSelector((state) => state.userSummary.summary);
    const isAdmin = userSummary.roleId === USER_ROLES.ADMIN;

    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const value = searchParams.get('tab');
        const numberValue = Number(value);
        if (
            value &&
            numberValue &&
            tabComponents.some((tab) => tab.id === numberValue)
        ) {
            setActiveTab(numberValue);
        } else {
            setSearchParams({
                tab: tabComponents[0].id.toString(),
            });
        }
    }, [searchParams]);

    const renderTabContent = () => {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return activeTabData ? activeTabData.content() : <></>;
    };

    const renderTabs = () => {
        return (
            <Card className="main-card">
                <div className="body_white_box practice-page-tabs m-0">
                    <div className="body_inner_content">
                        <div className="RRT__container">
                            <div className="RRT__tabs body-tabs">
                                {AdminMarketplaceTabs?.map((item) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className={
                                                activeTab === item.id
                                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                                    : 'RRT__tab'
                                            }
                                            onClick={() => {
                                                setActiveTab(item.id);
                                                setSearchParams({
                                                    tab: item.id.toString(),
                                                });
                                            }}>
                                            {item.content}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {renderTabContent()}
                    </div>
                </div>
            </Card>
        );
    };

    const renderMarketplacePage = () => {
        return (
            <div>
                <div>
                    <div className="main-title-content">
                        <div className="title-breadcrumb">
                            <div className="page-title">
                                <h3>Marketplace Admin</h3>
                            </div>
                            <Breadcrumb>
                                <BreadcrumbItem>
                                    <HomeButton />
                                </BreadcrumbItem>
                                <BreadcrumbItem active>
                                    Marketplace Admin Home
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                    </div>
                </div>

                {renderTabs()}
            </div>
        );
    };

    return (
        <Layout>
            {isAdmin ? (
                renderMarketplacePage()
            ) : (
                <h1>You don't have an access to see this page.</h1>
            )}
        </Layout>
    );
};

export default AdminMarketplace;
